import { injectable } from "inversify";
import DashboardRepository from "../../repositories/dashboard.repository";
import { Either } from "fp-ts/lib/Either";
import ErrorEntity from "../../entities/error.entity";
import MasterItemEntity from "../../entities/master_item.entity";

interface props {
    dashboardRepository: DashboardRepository;
}

@injectable()
class GetClientsListUseCase {
    private dashboardRepository: DashboardRepository;

    constructor({ dashboardRepository }: props) {
        this.dashboardRepository = dashboardRepository;
    }

    public call = async (): Promise<Either<ErrorEntity, MasterItemEntity[]>> => {
        return this.dashboardRepository.getClientsList();
    }
}

export default GetClientsListUseCase;

export const GetClientsListUseCaseName = "GetClientsListUseCase";